export const iconFontAwesomeHandsHandPointDown = (
	<i className="fa-solid fa-hand-point-down"></i>
);
